import { Map, fromJS } from 'immutable';
import { isEmpty } from 'lodash';

import PartnerInfoConstants from 'Shared/constants/PartnerInfo.constants';

const initialState = Map({
  [PartnerInfoConstants.State.PARTNER_INFO]: Map(),
});

export const PartnerInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case PartnerInfoConstants.Actions.GET_PARTNER_INFO_SUCCESS:
      if (isEmpty(action.payload)) {
        return state;
      }

      return state.setIn([PartnerInfoConstants.State.PARTNER_INFO], Map(fromJS(action.payload)));
    default:
      return state;
  }
};
